import { useCallback, useState } from "react";
import { MAX_BULK_EVENT_RESET } from "./bulkEventReset";

/**
 * The review queue's trip selection for a bulk Event Reset. A select-all remembers how many trips
 * it picked so the header checkbox stays fully checked while all of them still are; clearing the
 * selection forgets that count too, or a later manual pick of the same number of trips would read
 * as "all selected".
 */
export const useTripSelection = () => {
  const [selectedTripIds, setSelectedTripIds] = useState<number[]>([]);
  const [selectAllCount, setSelectAllCount] = useState<number | null>(null);
  const allMatchingSelected = selectAllCount !== null && selectAllCount > 0 && selectedTripIds.length === selectAllCount;

  const selectAll = useCallback((tripIds: number[]) => {
    const capped = tripIds.slice(0, MAX_BULK_EVENT_RESET);
    setSelectedTripIds(capped);
    setSelectAllCount(capped.length);
  }, []);

  // A manual pick never takes the selection past what one reset may take.
  const toggle = useCallback((tripId: number, checked: boolean) => {
    setSelectedTripIds((prev) => {
      if (!checked) return prev.filter((id) => id !== tripId);
      if (prev.includes(tripId) || prev.length >= MAX_BULK_EVENT_RESET) return prev;
      return [...prev, tripId];
    });
  }, []);

  const clear = useCallback(() => {
    setSelectedTripIds([]);
    setSelectAllCount(null);
  }, []);

  return { selectedTripIds, allMatchingSelected, selectAll, toggle, clear };
};
